import { createBrandConfig } from '@search/core/brands/createBrandConfig';
import { Order } from '@search/core/brands/models/Order';
import { serpStaticAssetsPath } from '@search/core/helpers/constants';
import { FlagshipLayout } from '../layouts/flagshipLayout/flagshipLayout';
export const Configuration = createBrandConfig({
    id: 'iwt',
    brand: 'immowelt',
    mfes: { savedSearchBrandId: 'iwt', favoriteHeartBrandId: 'immowelt' },
    searchType: 'classified',
    template: FlagshipLayout,
    portal: 'immowelt.de',
    defaultPlaceId: 'AD08DE7633',
    pageSize: 30,
    autoPromo: {
        autoPromos: [
            {
                type: 'pricemap',
                image: `${serpStaticAssetsPath}/images/autopromo-price.svg`,
                callToActionLink: '/immobilienpreise',
            },
            {
                type: 'estimation',
                image: `${serpStaticAssetsPath}/images/autopromo-estimation.svg`,
                callToActionLink: '/immobilienbewertung',
            },
        ],
        position: 12,
    },
    variant: 'flagship',
    defaultOrder: Order.Relevancy,
    sortExplanationPath: '/immoweltag/agb/otp',
    publicUriTemplate: 'https://<%= stage %>.immowelt.de',
    hotjarConfiguration: {
        id: 1377412,
        version: 6,
    },
    tracking: {
        avSite: 'IWT',
        getTrackingLegacy: () => undefined,
    },
    analytics: {
        portal: 'IWT-DEU',
    },
    featureFlags: [],
    lastSearchesLocalStorageKey: 'lastImmoweltSearches',
    displayMapToggle: true,
    ads: {
        desktop: {
            0: 'inline1',
            4: 'inline2',
            8: 'inline3',
            16: 'inline4',
            20: 'inline5',
            25: 'inline6',
        },
        mobile: {
            0: 'banner',
            4: 'understitial',
            8: 'inline1',
            16: 'inline2',
            20: 'inline3',
            25: 'inline4',
        },
    },
    suggestionSlots: [8, 21],
    hideCDPLinks: false,
    hideCDPUrlParams: true,
    displayPartnerLinks: true,
    dataDomeConfiguration: {
        ddJsKey: '8C7191D8AA1BF5FBB1B84DC7268196',
        domain: 'immowelt.de',
    },
});
